import makeSlice from '@web/slices/additionalOption/sliceMaker'

const slice = makeSlice()

export default slice.reducer
